import * as Set1 from './set_1';
import * as Set2 from './set_2';
import * as Set3 from './set_3';

export type IconSet<Type> = {
  [Key in keyof Type]: Key;
};

export const ReduceIconSet = <T extends object>(set: T): IconSet<T> =>
  (Object.keys(set) as Array<keyof T>).reduce((obj: IconSet<T>, key: keyof T) => {
    obj[key] = key;
    return obj;
  }, {} as IconSet<T>);

export const IconsV1: IconSet<typeof Set1> = ReduceIconSet(Set1);
export const IconsV2: IconSet<typeof Set2> = ReduceIconSet(Set2);
export const IconsV3: IconSet<typeof Set3> = ReduceIconSet(Set3);

export const Icons = Object.assign({}, IconsV1, IconsV2, IconsV3);
export interface Icons extends IconSet<typeof Set1 & typeof Set2 & typeof Set3> {}
